import React, {useRef, useState} from "react";
import {useNavigate} from "react-router-dom";
import dashboard from "../../assets/css/dashboard.module.scss";
import {Grid} from "@mui/system";
import NewProposalIcon from "../../assets/img/dashboard/new-proposal.svg";
import {useDispatch, useSelector} from "react-redux";
import {selectAuthState, setAuthData} from "../../store/authSlice";
import {useEffect} from "react";
import {DASHBOARD} from "../../constants/apiConstant";
import {selectUiState, setUiData} from "../../store/uiSlice";
import GlobalNotificationPopup from "../global-fields/GlobalNotificationPopup";
import {initialFormValidations, removeCookies} from "../../constants/helper";
import {selectDataStoreState, setDataStore} from "../../store/dataSlice";
import DashboardFooter from "./dashboard-footer/DashboardFooter";
import Cookies from "js-cookie";
import {Button, Stack} from "@mui/material";
import {styled, alpha} from "@mui/material/styles";
import Menu from "@mui/material/Menu";
import MenuItem from "@mui/material/MenuItem";
import Divider from "@mui/material/Divider";
import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";

const StyledMenu = styled((props) => (
  <Menu
    elevation={0}
    anchorOrigin={{
      vertical: "bottom",
      horizontal: "right",
    }}
    transformOrigin={{
      vertical: "top",
      horizontal: "right",
    }}
    {...props}
  />
))(({theme}) => ({
  "& .MuiPaper-root": {
    borderRadius: 6,
    marginTop: theme.spacing(1),
    minWidth: 180,
    color: "rgb(55, 65, 81)",
    boxShadow:
      "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    "& .MuiMenu-list": {
      padding: "4px 0",
    },
    "& .MuiMenuItem-root": {
      "& .MuiSvgIcon-root": {
        fontSize: 18,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
        ...theme.applyStyles("dark", {
          color: "inherit",
        }),
      },
      "&:active": {
        backgroundColor: alpha(
          theme.palette.primary.main,
          theme.palette.action.selectedOpacity
        ),
      },
    },
    ...theme.applyStyles("dark", {
      color: theme.palette.grey[300],
    }),
  },
}));

const Dashboard = () => {
  // const location = useLocation();
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const {user, dashboardData, selectedClient} = useSelector(selectAuthState);
  const {proposalStep, proposal_id} = useSelector(selectDataStoreState);
  const {dynamicHeaderHeight} = useSelector(selectUiState);
  // console.log("USER DAASHBOARD", proposalStep,proposal_id);
  const firstCall = useRef(false);
  const [dynamicHeight, setdynamicHeight] = useState(0);
  // const [anchorEl, setAnchorEl] = React.useState(null);

  const [anchorEl, setAnchorEl] = React.useState(null);
  const open = Boolean(anchorEl);
  const handleClick = (event) => {
    setAnchorEl(event.currentTarget);
  };
  const handleClose = () => {
    setAnchorEl(null);
  };

  // const handleClick = (event) => {
  //   setAnchorEl(event.currentTarget);
  // };

  // const handleClose = () => {
  //   setAnchorEl(null);
  // };

  // const open = Boolean(anchorEl);
  const id = open ? "simple-popover" : undefined;
  useEffect(() => {
    const checkDevice = () => {
      const width = window.innerWidth;

      if (width < 1024) {
        setdynamicHeight("auto");
      } else if (width >= 1024 && width < 1280) {
        setdynamicHeight(`calc(100vh - ${dynamicHeaderHeight + 96}px)`);
      } else if (width >= 1280 && width <= 1441) {
        setdynamicHeight(`calc(100vh - ${dynamicHeaderHeight + 96}px)`);
      } else if (width > 1440) {
        setdynamicHeight(`calc(100vh - ${dynamicHeaderHeight + 66}px)`);
      }
    };

    checkDevice();
    window.addEventListener("resize", checkDevice);
    return () => window.removeEventListener("resize", checkDevice);
  }, []);

  const fetchDashboardData = async (e) => {
    dispatch(
      setUiData({
        showLoader: true,
      })
    );
    Cookies.remove("consent_shown");
    if (proposalStep > 1 && selectedClient === null) {
      dispatch(
        setDataStore({
          proposalStep: 1,
          previous_proposal_id: null,
          editingSubmitted: false,
        })
      );
    }
    if (proposal_id && selectedClient === null) {
      dispatch(
        setDataStore({
          proposal_id: null,
          previous_proposal_id: null,
          editingSubmitted: false,
          clickedSteps: [],
        })
      );
    }

    let data = {user_id: user?.id, user_type: user?.user_type};

    const options = {
      method: DASHBOARD.method,
      headers: DASHBOARD.headers,
      body: JSON.stringify(data),
    };

    fetch(DASHBOARD.url, options)
      .then((response) => response.json())
      .then((res) => {
        if (res.status == 0) {
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
          GlobalNotificationPopup({type: "error", message: res?.message});
        } else if (res.status == 1) {
          dispatch(
            setAuthData({
              dashboardData: res?.details,
            })
          );
          dispatch(
            setUiData({
              showLoader: false,
            })
          );
        }
      })
      .catch((error) => {
        removeCookies("isLogin");
        GlobalNotificationPopup({type: "error", message: error});
        console.log("error", error);
        dispatch(
          setUiData({
            showLoader: false,
          })
        );
        navigate("/");
      });
  };

  useEffect(() => {
    if (!firstCall.current && user?.user_type) {
      firstCall.current = true;
      fetchDashboardData();
    }
  }, [user]);

  const handleJBbtn = (d, type) => {
    if (
      user?.user_type === "agent" &&
      proposal_id &&
      selectedClient &&
      d?.url === "/new-proposal"
    ) {
      dispatch(
        setDataStore({
          jewelers_block_type: type,
          proposalStep: 1,
          proposal_id: null,
          previous_proposal_id: null,
          editingSubmitted: false,
          clickedSteps: [],
          formValidations: initialFormValidations,
        })
      );
      dispatch(setAuthData({selectedClient: null}));
      navigate("/clients");
      return;
    } else if (
      user?.user_type === "agent" &&
      !proposal_id &&
      !selectedClient &&
      d?.url === "/new-proposal"
    ) {
      // dispatch(
      //   setDataStore({
      //     jewelers_block_type: type,
      //   })
      // );
      navigate("/clients");
      return;
    } else if (user?.user_type !== "agent") {
      dispatch(
        setDataStore({
          jewelers_block_type: type,
          proposalStep: 1,
          proposal_id: null,
          previous_proposal_id: null,
          editingSubmitted: false,
          clickedSteps: [],
          formValidations: initialFormValidations,
        })
      );
      navigate(d?.url);
    }
  };
  // console.log("dashboardData", dashboardData);
  return (
    <>
      <section
        className={dashboard.dashboardSection}
        // style={{ height: dynamicHeight }}
      >
        <Grid container spacing={0} className="customeContainer">
          <Grid size={{xs: 12}} sx={{mt: 4}}>
            <Grid container spacing={3}>
              {!dashboardData?.length ? (
                Array(6)
                  .fill()
                  .map((i, idx) => (
                    <Grid size={{xs: 12, xl: 4, lg: 4, sm: 12}}>
                      <div className={dashboard.dashboardCard}>
                        <div className={dashboard.dashBText}>
                          <img src={NewProposalIcon} alt="np-icon" />
                          <p>Title</p>
                        </div>
                        <h2>{idx}</h2>
                      </div>
                    </Grid>
                  ))
              ) : dashboardData?.length ? (
                dashboardData.map((d, dId) => (
                  <Grid size={{xs: 12, xl: 4, lg: 4, sm: 12}} key={dId}>
                    <div
                      className={dashboard.dashboardCard}
                      onClick={() => {
                        if (d?.title === "New Proposal") {
                          return;
                        }

                        navigate(d?.url);
                      }}
                    >
                      <div className={dashboard.dashBText}>
                        <img src={d.icon} alt={d?.title} />
                        <p>{d?.title}</p>
                      </div>
                      {d?.count ? <h2 aria-label="title">{d?.count}</h2> : null}
                      {d?.title === "New Proposal" ? (
                        <>
                          <div className={dashboard.DashPropoFormBtn}>
                            <Button
                              id="demo-customized-button"
                              aria-controls={
                                open ? "demo-customized-menu" : undefined
                              }
                              aria-haspopup="true"
                              aria-expanded={open ? "true" : undefined}
                              variant="contained"
                              disableElevation
                              sx={{mr: 1}}
                              onClick={handleClick}
                              // onClick={() => {

                              //   if (
                              //     user?.user_type === "agent" &&
                              //     proposal_id &&
                              //     selectedClient &&
                              //     d?.url === "/new-proposal"
                              //   ) {
                              //     dispatch(
                              //       setDataStore({
                              //         proposalStep: 1,
                              //         proposal_id: null,
                              //         previous_proposal_id: null,
                              //         editingSubmitted: false,
                              //         clickedSteps: [],
                              //         formValidations: initialFormValidations,
                              //       })
                              //     );
                              //     dispatch(setAuthData({ selectedClient: null }));
                              //     navigate("/clients");
                              //     return;
                              //   } else if (
                              //     user?.user_type === "agent" &&
                              //     !proposal_id &&
                              //     !selectedClient &&
                              //     d?.url === "/new-proposal"
                              //   ) {
                              //     navigate("/clients");
                              //     return;
                              //   } else if (user?.user_type !== "agent") {
                              //     dispatch(
                              //       setDataStore({
                              //         proposalStep: 1,
                              //         proposal_id: null,
                              //         previous_proposal_id: null,
                              //         editingSubmitted: false,
                              //         clickedSteps: [],
                              //         formValidations: initialFormValidations,
                              //       })
                              //     );
                              //     navigate(d?.url);
                              //   }
                              // }}
                              endIcon={<KeyboardArrowDownIcon />}
                            >
                              Jewelers Block
                            </Button>

                            <StyledMenu
                              id="demo-customized-menu"
                              slotProps={{
                                list: {
                                  "aria-labelledby": "demo-customized-button",
                                },
                              }}
                              anchorEl={anchorEl}
                              open={open}
                              onClose={handleClose}
                              anchorOrigin={{
                                vertical: "bottom",
                                horizontal: "left",
                              }}
                              transformOrigin={{
                                vertical: "top",
                                horizontal: "left",
                              }}
                            >
                              <MenuItem
                                onClick={() => handleJBbtn(d, 0)}
                                disableRipple
                              >
                                NON LLOYDS APPLICATION
                              </MenuItem>
                              <Divider sx={{my: 0.5}} />

                              <MenuItem
                                onClick={() => handleJBbtn(d, 1)}
                                disableRipple
                              >
                                LLOYDS APPLICATION
                              </MenuItem>
                            </StyledMenu>

                            <Button
                              onClick={() => {
                                if (
                                  user?.user_type === "agent" &&
                                  !proposal_id &&
                                  !selectedClient &&
                                  d?.url === "/new-proposal"
                                ) {
                                  dispatch(
                                    setDataStore({
                                      proposalStep: 1,
                                      proposal_id: null,
                                      previous_proposal_id: null,
                                      editingSubmitted: false,
                                      clickedSteps: [],
                                      formValidations: initialFormValidations,
                                    })
                                  );
                                  navigate("/clients");
                                  // navigate('/client-select');
                                  return;
                                }
                                navigate("/diamond-form");
                              }}
                              variant="outlined"
                              className="jewelersBlockBtn"
                            >
                              Processing Risk
                            </Button>
                          </div>
                        </>
                      ) : null}
                    </div>
                  </Grid>
                ))
              ) : (
                <Grid size={{xs: 12, lg: 12}} key={0}>
                  <div>
                    <p>NO DATA FOUND !</p>
                  </div>
                </Grid>
              )}
            </Grid>
          </Grid>
        </Grid>
      </section>
      <DashboardFooter />
    </>
  );
};

export default Dashboard;
